import React, { useState, useEffect } from "react";

import InputField from "../../../common/InputField";
import * as Yup from "yup";

import { Form, Formik } from "formik";
import { Typography, Box, Container } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../common/Buttons";
import {
  getGuardianOridinance,
  postGuardianOridinance,
} from "../../../services/documentServices";
import { toast } from "react-hot-toast";
import {
  getUserIdFromLocalStorage,
  setStepStatus,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const validate = (t) => {
  return Yup.object({
    name: Yup.string().max(50, t("max-50-characters")).nullable(),
    address: Yup.string().nullable(),
    email: Yup.string()
      .matches(
        // eslint-disable-next-line
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        t("Must-be-ValidEmail")
      )
      .nullable(),
    dateOfBirth: Yup.string().nullable(),
    phone: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .test(
        "len",
        t("less-than-15"),
        (val) => !val || (val && val.toString().length <= 15)
      )
      .nullable()
      .typeError(t("must-be-number")),
    // phone: Yup.string()
    //   .matches(/^[0-9\/]+$/, t("must-be-number"))
    //   .test(
    //     "len",
    //     t("less-than-15"),
    //     (val) => !val || (val && val.toString().length <= 15)
    //   ),
  });
};

const SecondaryGuardian = (props) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    name: "",
    address: "",
    email: "",
    dateOfBirth: "",

    phone: "",
  });

  async function fetchData() {
    setIsLoading(true);
    props.setButtonDisabled(true);
    try {
      const result = await getGuardianOridinance(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (result.payLoad.secondaryGuardian !== null) {
          const { dateOfBirth, ...rest } = result.payLoad.secondaryGuardian;
          setInitialValues({ ...rest, dateOfBirth: dateOfBirth?.slice(0, 10) });
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
      props.setButtonDisabled(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const handleSubmit = async (values) => {
    props.setButtonDisabled(true);
    const {
      stepStatus,
      guardianOrdinanceId,
      secondaryGuardianId,
      dateOfBirth,
      ...rest
    } = values;
    const payload = {
      ...data,
      secondaryGuardian: {
        ...rest,
        guardianOrdinanceId,
        secondaryGuardianId,
        dateOfBirth: dateOfBirth === "" ? null : dateOfBirth,
        stepStatus: setStepStatus(dateOfBirth, { ...rest }),
      },
    };
    const result = await postGuardianOridinance(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      props.next();
    }
    props.setButtonDisabled(false);
  };
  const handleDateOfBirthKeyDown = (event) => {
    event.preventDefault(); 
  };
  return (
    <>
      <Container
        className="summary-table documents-card-height"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {isLoading ? (
          <Box component="div" className="loader-container">
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <Box sx={{ marginTop: "40px" }} width="60%">
            <Typography variant="p" paragraph align="left" color="color.black">
              {t("guardian-text-2")}
            </Typography>
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validate(t)}
              onSubmit={(values) => {
                // const { phone, ...rest } = values;
                // let payload = { phone: phone.replace(/\//g, ""), ...rest };
                // handleSubmit(payload);
                handleSubmit(values);
              }}
            >
              {(formik) => (
                <Form id="form_submit" onSubmit={formik.handleSubmit}>
                  <InputField
                    fullWidth
                    variant="standard"
                    placeholder="John"
                    label={t("input-5")}
                    name="name"
                    type="text"
                  />

                  <InputField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    label={t("input-2")}
                    name="dateOfBirth"
                    type="date"
                    onKeyDown={handleDateOfBirthKeyDown} 

                  />

                  <InputField
                    variant="standard"
                    placeholder="address "
                    label={t("input-12")}
                    name="address"
                    type="text"
                  />

                  <InputField
                    fullWidth
                    variant="standard"
                    placeholder="demo@gmail.com"
                    label={t("input-3")}
                    name="email"
                    type="email"
                  />
                  <InputField
                    fullWidth
                    variant="standard"
                    placeholder="2842394789"
                    label={t("input-4")}
                    name="phone"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                  />
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </Container>
    </>
  );
};

export default SecondaryGuardian;
